// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn[data-v-4c895ab8]{display:inline-flex;align-items:center;justify-content:center}.btn[data-v-4c895ab8] i{padding:0 3px}", ""]);
// Exports
module.exports = exports;
